import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/typingIndicator/SlidingDotsTypingIndicator.module_built.css";
const classes = {"sliding-dots-typing-indicator":"wQOMcSW_sliding-dots-typing-indicator","sliding-dots-typing-indicator__image":"wQOMcSW_sliding-dots-typing-indicator__image"}
export default classes

const _sliding_dots_typing_indicator0 = classes["sliding-dots-typing-indicator"]
export { _sliding_dots_typing_indicator0 as "sliding-dots-typing-indicator" }

const _sliding_dots_typing_indicator__image0 = classes["sliding-dots-typing-indicator__image"]
export { _sliding_dots_typing_indicator__image0 as "sliding-dots-typing-indicator__image" }
